import React from "react";
import { PropertyLandingScreenContainer } from "src/containers";

export const PropertyLandingScreen = () => {
  return <PropertyLandingScreenContainer />;
};
